import CustomTable from '@/common/Table';

export default function FollowUpTable({
  loading,
  columns,
  dataSource,
  pagination,
  onChange
}) {
  return (
    <CustomTable
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      onChange={onChange}
      pagination={pagination}
      emptyText={'No follow-ups to show'}
    />
  );
}
